import React, { useState, useEffect } from "react";

// import { animateScroll as scroll } from "react-scroll";
import {
  Nav,
  NavLogoV,
  NavLogoH,
  MenuIcon,
  Sidebar,
  CenterBar,
  NavMenu,
  NavItem,
  NavLinks,
  CrossIcon,
  LandingPage,
} from "./NavbarElements";
import { useScrollDirection } from "../../hooks/useScollDirection";

import logo from "../../assets/images/logo.svg";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const scrollDir = useScrollDirection();
  const toggleMenu = () => setMenuOpen((o) => !o);
  const [yOffset, setyOffset] = useState(window.pageYOffset);

  useEffect(() => {
    const listner = () => setyOffset(window.pageYOffset);
    window.addEventListener("scroll", listner);
    return () => window.removeEventListener("scroll", listner);
  }, [setyOffset]);

  return (
    <>
      <LandingPage>
        <img src={logo} alt="" />
      </LandingPage>
      <Nav
        menuopen={menuOpen ? 1 : 0}
        scrollDir={!scrollDir || yOffset < 200 ? 1 : 0}
      >
        <Sidebar menuopen={menuOpen ? 1 : 0}>
          <MenuIcon onClick={toggleMenu}>
            <i className="fa fa-bars" />
          </MenuIcon>
          <NavLogoV
            to="/#top"
            onClick={() => setMenuOpen(false)}
            menuopen={menuOpen ? 1 : 0}
          >
            PK Builders
          </NavLogoV>
        </Sidebar>
        <CenterBar menuopen={menuOpen ? 1 : 0}>
          <CrossIcon onClick={toggleMenu}>
            <i className="fa fa-times" />
          </CrossIcon>
          <NavLogoH to="/#top" onClick={toggleMenu} menuopen={menuOpen ? 1 : 0}>
            PK Builders
          </NavLogoH>
          <NavMenu>
            <NavItem>
              <NavLinks to="/#top" onClick={toggleMenu}>
                Home
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="/projects#top" onClick={toggleMenu}>
                Projects
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="/about#top" onClick={toggleMenu}>
                About
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="/contactus#top" onClick={toggleMenu}>
                Contact Us
              </NavLinks>
            </NavItem>
          </NavMenu>
        </CenterBar>
      </Nav>
    </>
  );
};

export default Navbar;
